/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import './styles.scss'
import CredentialsTab from '../../../../components/NxCredentialsTable/CredentialsTab'
import { company } from '../../../../api'
import SelectorBrandDelegation from '../../../../components/SelectorBrandDelegation'
import { useSelector } from 'react-redux'
import Nixi1Spinner from 'components/Nixi1Spinner'

const { credentials: credentialsApi } = company

export default function NxCredentialsRow(props) {
  const { user } = useSelector((state) => state)
  const [loading, setLoading] = useState(true)
  const [config, setConfig] = useState({})
  const [data, setData] = useState({ credentials: [], schema: {} })
  const [lockedButtons, setLockedButtons] = useState(false)

  useEffect(() => {
    if (props.activeKey) {
      getCredentials()
    } else {
      setData({ credentials: [], schema: {} })
      setConfig({})
    }
  }, [props.activeKey])

  const getCredentials = (brand, delegation) => {
    if (user.brands.length > 0) {
      if (!brand) {
        setLoading(false)

        return
      } else if (!delegation) {
        const isBrand = user.brands.find((b) => b.id === brand)

        if (isBrand && isBrand.delegations && isBrand.delegations.length) {
          setLoading(false)

          return
        }
      }
    }

    setLoading(true)
    const { provider: key, type } = props

    credentialsApi
      .getCredentialsByKey({ key, type, brand, delegation })
      .then(({ data, status }) => {
        if (status === 200) {
          setData({ credentials: data.results, schema: data.schema })
          setConfig({ brand, delegation })
          if (!['owner', 'admin', 'root'].includes(user.role) && !delegation) {
            setLockedButtons(true)
          }
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }

  return (
    <tr hidden={props.hidden} className={'animated fadeIn'}>
      <td colSpan={3}>
        {props.type !== 'ecommerce' &&
          <>
            <SelectorBrandDelegation onChange={getCredentials} lockedButtons={loading} show={props.hidden} user={user} />
            {loading ? (
              <Nixi1Spinner width={'25px'} height={'25px'} />
            ) : (
              <CredentialsTab
                credentials={data.credentials}
                schema={data.schema}
                brandSelected={config.brand}
                delegationSelected={config.delegation}
                lockedButtons={lockedButtons}
                onToggleActive={props.onToggleActive}
                updateStatus={props.updateStatus}
                userRole={user.role}
              />
            )}
          </>
        }
        {/* Ecommerce case */}
        {props.type === 'ecommerce' && <>
          {loading ? (
            <Nixi1Spinner width={'25px'} height={'25px'} />
          ) : (
            <CredentialsTab
              credentials={data.credentials}
              schema={data.schema}
              brandSelected={config.brand}
              delegationSelected={config.delegation}
              lockedButtons={lockedButtons}
              onToggleActive={props.onToggleActive}
              updateStatus={props.updateStatus}
              userRole={user.role}
            />
          )}
        </>
        }

      </td>
    </tr>
  )
}
